import * as URL from "../url.helper";
import { post } from "../api.helper";

export const refreshToken = data => post(URL.REFRESH_TOKEN_URL, data, {skipInterceptor: true});